// Gedeelde PT-admin helpers: statuslabels, kleuren, formatters
export const ACCENT = "var(--joh-accent)";

export const BOOKING_STATUS = {
  pending: { nl: "PENDING", color: "#D4A93A" },
  approved: { nl: "CONFIRMED", color: "#4ADE80" },
  completed: { nl: "COMPLETED", color: "#4ADE80" },
  cancelled: { nl: "CANCELLED", color: "#F87171" },
  declined: { nl: "DECLINED", color: "#F87171" },
  no_show: { nl: "NO SHOW", color: "#F87171" },
};

export const CLIENT_STATUS = {
  new: { nl: "Nieuwe aanvraag", color: "#D4A93A" },
  intake: { nl: "Intake", color: "#60A5FA" },
  active: { nl: "Actief", color: "#4ADE80" },
  paused: { nl: "Tijdelijk gepauzeerd", color: "#A3A3A3" },
  completed: { nl: "Traject afgerond", color: "#DDD6CB" },
  declined: { nl: "Afgewezen", color: "#F87171" },
};

export const PAYMENT_STATUS = {
  ready: { nl: "Not paid — link klaar", color: "#60A5FA" },
  sent: { nl: "Payment sent", color: "#D4A93A" },
  overdue: { nl: "Overdue", color: "#F87171" },
  paid: { nl: "Paid", color: "#4ADE80" },
  expired: { nl: "Verlopen", color: "#F87171" },
  none: { nl: "Nog geen betaalverzoek", color: "#4A4A4A" },
};

export const COMM_LABELS = {
  registration: "Registratie",
  booking_request: "Boekingsaanvraag ontvangen",
  booking_confirmed: "Boekingsbevestiging",
  booking_declined: "Afwijzing verstuurd",
  payment_created: "Betaalverzoek aangemaakt",
  payment_request: "Betaallink verstuurd",
  payment_reminder: "Betalingsherinnering verstuurd",
  payment_received: "Betaling ontvangen",
  feedback_mail: "Feedbackmail verstuurd",
};

export const eur = (cents) => {
  const v = (cents || 0) / 100;
  return v === Math.round(v) ? `€${v}` : `€${v.toFixed(2).replace(".", ",")}`;
};

export const chip = (color) => ({ color, borderColor: `${color}55` });

export function StatusChip({ map, value, testid }) {
  const s = map[value] || { nl: value || "—", color: "#A3A3A3" };
  return (
    <span className="chip px-2 py-0.5 border inline-block" style={chip(s.color)} data-testid={testid}>{s.nl.toUpperCase()}</span>
  );
}
